export default __webpack_public_path__ + "static/launch-e1abe887b1c1d6f5eb5df78113628a98.jpg";